import { BranchingElbowConnectorVertical } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/branchine-elbow-connector-vertical';
import { BranchingElbowConnector } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/branching-elbow-connector';
import { mean } from 'd3-array';

interface Props {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
  branchX?: number;
  branchY?: number;
  opacity?: number;
  vertical?: boolean;
  addedHorizontalMargin?: number;
}

interface Point {
  x: number;
  y: number;
}

export function ElbowConnector(props: Props) {
  const { x1, x2, y1, y2, addedHorizontalMargin = 0 } = props;

  const start: Point = {
    x: x1,
    y: y1,
  };
  const end: Point = {
    x: x2,
    y: y2,
  };

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  if (props.vertical) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const branchY = mean([y1, y2])!;
    return <BranchingElbowConnectorVertical startPoint={start} endPoints={[end]} branchY={branchY} />;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const branchX = props.branchX !== undefined ? props.branchX : mean([x1, x2])!;
  return (
    <BranchingElbowConnector
      startPoint={start}
      endPoints={[end]}
      branchX={branchX}
      addedHorizontalMargin={addedHorizontalMargin}
    />
  );
}
